import { Banner } from "@/ui/Banner";
import { Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";

export const SpecialismPageBannerSection = ({ className, item, title }) => {
  const pathPrefix = `page.specialism.${item.url_slug}.banner`;
  const locale = useLocale();

  return (
    <Banner
      className={className}
      title={
        <DynamicText
          path={title ? `${title.path}.${locale}` : `${pathPrefix}.title.${locale}`}
          tag="h1"
          dangerouslySetInnerHTML={title?.placeholders ? { __html: title.placeholders[locale] } : null}
        />
      }
      image={{ path: `${pathPrefix}.image`, src: "/assets/banners/specialism.png" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12}>
              <DynamicHtml path={`${pathPrefix}.text.${locale}`} />
            </Col>
            <Col xs={12} md={6}>
              <DynamicHtml path={`${pathPrefix}.text.col1.${locale}`} />
            </Col>
            <Col xs={12} md={6}>
              <DynamicHtml path={`${pathPrefix}.text.col2.${locale}`} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Banner>
  );
};
